// extracted by mini-css-extract-plugin
export default {"map_fig":"MapComponent_map_fig__wuedP"};